import imageChapa from '../assets/images/chapa-varios.png';
import imageChapaDetail from '../assets/images/chapas-detalle.png';

export const MISC = [
    {id: 'chapa-acanalada', title: 'Chapa acanalada', image: imageChapa, list: ['Por m² / Cal 27'], imageDetail: imageChapaDetail}
]


export const getMiscById = (id) => MISC.find(i => i.id === id); 